import script from "./TempoLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./TempoLite.vue?vue&type=script&setup=true&lang=ts"

import "./TempoLite.vue?vue&type=style&index=0&id=2bd82884&lang=less"

const __exports__ = script;

export default __exports__